// Default "Submission Requirements Checklist" on the Submit Manuscript page.
// Editable in Admin -> Site Settings (saved as site.submissionChecklist, one item per line).
export const DEFAULT_SUBMISSION_CHECKLIST = [
  'Blinded Main Manuscript File (DOCX/PDF) free of identifying author or institutional marks.',
  'Separate Title Page containing author names, affiliations, email addresses, and corresponding author details.',
  'Structured abstract (max 250 words) with 4–6 MeSH-compliant keywords.',
  'Institutional Ethics Committee (IEC/IRB) approval letter or signed patient consent form for clinical cases.',
  'Declared conflict of interest and financial disclosure statements included in title page.',
];

export const checklistFromText = (text) =>
  typeof text === 'string' && text.trim()
    ? text.split('\n').map((line) => line.trim()).filter(Boolean)
    : DEFAULT_SUBMISSION_CHECKLIST;
